import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoBitrateInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { VideoBitrateEnum } from '../../../types/enums/VideoBitrateEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VideoBitrateInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in VideoBitrateEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key.split(/(?=[A-Z])/).join(' ')}`,
        value: `${VideoBitrateEnum[key as keyof typeof VideoBitrateEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoBitrate: parseInt(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoBitrate: parseInt(option.value),
        });
      }
    }
  };

  return (
    <div className="video-bitrate-input">
      <div className="input-title">
        {t('producer.inputs.video-bitrate.title')}
        <Help
          title="Bitrate"
          text="Bitrate controls the amount of data used for your video stream per second.<br/><br/>- Higher bitrates provide better video quality but require more bandwidth.<br/>- Lower bitrates reduce data usage and are useful for viewers with limited network speeds, but may decrease video clarity.<br/><br/>Adjust this setting to balance video quality with available network capacity."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderVideoBitrate.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.video-bitrate.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.video-bitrate.footer')}</div>
    </div>
  );
};

export default React.memo(VideoBitrateInput);
